import React from "react";
import shared from "./NumericField.module.scss";

export const NumericField = ({ label, required, value, onChange, suffix, error, placeholder = "0", id }) => {
  const handleChange = (e) => {
    const raw = e.target.value;
    if (raw === "" || /^\d*\.?\d*$/.test(raw)) {
      onChange(raw);
    }
  };

  return (
    <div className={shared.field}>
      <label className={shared.label} htmlFor={id}>
        {label}
        {required && <span className={shared.required}>*</span>}
      </label>
      <div className={shared.inputWrap}>
        <input
          id={id}
          type="text"
          inputMode="decimal"
          className={`${shared.input} ${error ? shared.inputError : ""}`}
          value={value}
          onChange={handleChange}
          placeholder={placeholder}
          aria-invalid={!!error}
          aria-required={required}
        />
        {suffix && <span className={shared.suffix}>{suffix}</span>}
      </div>
      {error && <span className={shared.errorText}>{error}</span>}
    </div>
  );
};
